<template>
  <div
    style="
      background-color: #f0f2f5;
      margin: -20px -30px -30px -20px;
      padding: 20px 30px 30px 20px;
    "
  >
    <div
      style="
        background-color: #fff;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 2px;
      "
    >
      <div style="display: flex; align-items: center">
        <span style="margin-right: 60px; font-size: 20px"
          >本地图文模板管理</span
        >
        <a-button @click="goAdd" type="primary" icon="plus"
          >新建本地图文模板</a-button
        >
      </div>

      <div style="display: flex">
        <div style="margin-right: 20px">
          <a-input
            v-model="r_name"
            allowClear
            placeholder="请输入模板标题"
            style="width: 300px"
          />
        </div>

        <a-button
          @click="searchButton('button')"
          :loading="search_button_loading"
          type="primary"
          icon="search"
          >搜索</a-button
        >
      </div>
    </div>

    <div style="display: flex">
      <div style="width: 200px">
        <div
          class="big-menu-box"
          style="
            padding-right: 10px;
            background-color: #fff;
            padding-left: 10px;
            margin-top: 15px;
            border-radius: 2px;
            position: sticky;
            top: 65px;
          "
        >
          <div style="cursor: default; padding: 15px 0px 10px; font-size: 16px">
            书城渠道
          </div>
          <div style="margin-bottom: 10px">
            <a-input-search placeholder="搜索书城渠道" @search="onSearchChal" />
          </div>
          <div
            class="left-menu-box"
            style="
              height: 100%;
              overflow-y: overlay;
              margin-right: -10px;
              padding-right: 10px;
            "
            :style="{ height: left_book_height + 'px' }"
          >
            <div
              v-for="(item, index) in showBookList"
              :key="index"
              class="left-label"
              :class="[item.status ? 'select_menu' : '']"
              @click="changeBook(item, index)"
            >
              <div style="flex: 1; padding-left: 15px">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <div style="flex: 1; padding-left: 15px">
        <div
          style="
            margin-top: 15px;
            background-color: #fff;
            padding: 10px 0px 20px;
            border-radius: 2px;
          "
        >
          <div
            class="page-title"
            style="
              margin-bottom: 14px;
              font-size: 16px;
              padding-top: 4px;
              padding-left: 30px;
            "
          >
            {{ title_channel_name || "全部渠道" }}
            <a-button style="margin-left: 10px" @click="multShareClick"
              >批量分享</a-button
            >
          </div>
          <div>
            <div v-for="item in itemData" :key="item.id" class="item-box">
              <div
                class="item-box-title"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <a-checkbox
                  @change="checkChange(item, $event)"
                  :checked="r_id.includes(item.id)"
                >
                </a-checkbox>
                <a-tooltip :title="item.name" placement="topLeft"
                  ><span
                    style="
                      padding-right: 5px;
                      flex: 1;
                      margin-left: 5px;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 2;
                      overflow: hidden;
                      cursor: pointer;
                    "
                    >{{ item.name }}</span
                  ></a-tooltip
                >

                <div style="display: flex; flex-direction: column; width: 80px">
                  <a-tag
                    v-if="item.channel_name"
                    color="blue"
                    style="
                      text-align: center;
                      padding: 0 12px;
                      margin-bottom: 4px;
                    "
                  >
                    {{ item.channel_name }} </a-tag
                  ><a-tag
                    v-if="item.channel_name"
                    color="blue"
                    style="text-align: center; padding: 0 12px"
                  >
                    {{ type_map[item.type] || "H5" }}
                  </a-tag>
                </div>
              </div>

              <div style="position: relative">
                <img
                  class="item-top-img"
                  style=""
                  :src="
                    item.message[0].message_cover +
                    (item.message[0].message_cover.indexOf('?') > -1
                      ? ''
                      : '?x-oss-process=image/resize,h_150,m_lfit')
                  "
                  alt=""
                />
                <div class="item-top-title" style="">
                  {{ item.message[0].message_title }}
                </div>
              </div>
              <div v-for="(item_z, index_z) in item.message" :key="index_z">
                <div v-if="index_z > 0" class="item-cell-box">
                  <div style="flex: 1">{{ item_z.message_title }}</div>
                  <img
                    class="item-cell-img"
                    :src="
                      item_z.message_cover +
                      (item_z.message_cover.indexOf('?') > -1
                        ? ''
                        : '?x-oss-process=image/resize,h_100,m_lfit')
                    "
                    alt=""
                  />
                </div>
              </div>

              <div class="item-button-box" style="">
                <div
                  @click="handleButton(1, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  编 辑
                </div>
                <div
                  @click="handleButton(2, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  复 制
                </div>
                <div
                  @click="handleButton(5, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  分 享
                </div>
                <div
                  @click="handleButton(3, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  删 除
                </div>
                <div @click="handleButton(4, item)" class="handle-button">
                  同步到微信
                </div>
              </div>
            </div>
          </div>

          <div
            v-show="itemData.length == 0"
            style="text-align: center; text-align: center; padding: 80px 0 50px"
          >
            <a-icon style="font-size: 70px; color: #999" type="file-search" />
            <div style="color: #999; font-size: 16px; margin-top: 20px">
              内容为空
            </div>
          </div>

          <!-- 分页 -->
          <div style="clear: both"></div>
          <div
            style="
              text-align: center;
              margin-top: 30px;
              position: sticky;
              left: 30px;
            "
          >
            <!-- <a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" 
					show-quick-jumper show-size-changer :pageSizeOptions="['8','20','50','80','100','150','200','300','500']" @showSizeChange="changeSizeLimit"/> -->
            <a-pagination
              v-model="r_page"
              :pageSize="r_limit"
              :total="table_total"
              :showTotal="(total, range) => `共 ${total} 条`"
              :pageSizeOptions="[
                '8',
                '20',
                '30',
                '50',
                '80',
                '100',
                '150',
                '200',
              ]"
              @change="paginationChange"
              show-quick-jumper
              show-size-changer
              @showSizeChange="changeSizeLimit"
            />
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="同步到微信草稿箱"
      :visible="wx_visible"
      :confirm-loading="wx_confirmLoading"
      @ok="wxHandleOk"
      @cancel="wxHandleCancel"
      width="1100px"
    >
      <div>
        <div style="margin-bottom: 15px; font-size: 16px; color: #333">
          选择公众号（当前书城：{{ s_channel_name }}）
        </div>
        <div style="max-height: 300px; overflow-y: overlay">
          <div
            v-for="(item, index) in gzhData"
            :key="index"
            style="margin-bottom: 25px"
          >
            <a-checkbox
              :indeterminate="item.indeterminate_all"
              :checked="item.checked_all"
              @change="onCheckAllChange($event, item, index)"
            >
              {{ item.label }}
            </a-checkbox>
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-left: 20px;
                margin-top: 10px;
              "
            >
              <div
                v-for="(item_z, index_z) in item.value"
                :key="index_z"
                style="margin-bottom: 5px; margin-right: 10px"
              >
                <a-checkbox
                  :checked="item_z.checked_z"
                  @change="onCheckChange($event, index, index_z)"
                >
                  {{ item_z.gzh_name }}
                </a-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex">
          <div style="margin-right: 50px; width: 450px">
            <div class="form-cell-box">
              <a-checkbox :checked="ccccc" @change="onAddChange"></a-checkbox>
              <div
                class="class-title"
                style="width: auto; margin-left: 15px; font-size: 16px"
              >
                同时新建批量群发
                <a-popover>
                  <template slot="content">
                    <p style="width: 240px">
                      创建群发任务时，基于人群选择、公众号模式和草稿类型确定最终发送用户。
                    </p>
                  </template>
                  <a-icon
                    type="question-circle"
                    style="cursor: pointer; margin-left: 4px"
                  />
                </a-popover>
              </div>
            </div>

            <template v-if="s_add_control == 2">
              <div class="form-cell-box">
                <div class="class-title">群发类型</div>
                <div>
                  <a-radio-group
                    @change="messTypeA"
                    name="radioGroup"
                    :value="s_send_time_type"
                  >
                    <a-radio :value="2"> 定时群发 </a-radio>
                    <a-radio :value="1"> 立刻群发 </a-radio>
                  </a-radio-group>
                </div>
              </div>

              <div v-if="s_send_time_type == 2" class="form-cell-box">
                <div class="class-title">发送时间</div>

                <a-date-picker
                  show-time
                  style="width: 340px"
                  @change="onSendChange"
                  :allowClear="false"
                  placeholder="选择发送时间"
                  :disabledDate="disabledDate"
                />
              </div>

              <div class="form-cell-box">
                <div class="class-title">人群</div>
                <div>
                  <a-radio-group
                    @change="messTypeB"
                    name="radioGroup"
                    :value="s_send_type"
                  >
                    <a-radio :value="1"> 全部用户 </a-radio>
                  </a-radio-group>
                </div>
              </div>

              <div v-if="s_send_type == 1" class="form-cell-box">
                <div class="class-title"></div>
                <a-checkbox :checked="aaaaa" @change="onTagChange">
                  <span style="user-select: none"
                    >通过标签 星标组 群发，新用户看不到历史文章</span
                  >
                </a-checkbox>
              </div>
            </template>
          </div>

          <div>
            <div class="form-cell-box">
              <a-checkbox
                :checked="imgTxt_checked"
                @change="onAddChangeC"
              ></a-checkbox>
              <div
                class="class-title"
                style="width: auto; margin-left: 15px; font-size: 16px"
              >
                同时设置智能图文
                <a-popover>
                  <template slot="content">
                    <p style="width: 240px">
                      草稿同时生成H5、小程序两个版本时，智能图文只设置小程序的版本。
                    </p>
                  </template>
                  <a-icon
                    type="question-circle"
                    style="cursor: pointer; margin-left: 4px"
                  />
                </a-popover>
              </div>
            </div>

            <template v-if="imgTxt_checked">
              <div class="form-cell-box">
                <div class="class-title">推送时间</div>
                <div style="display: inline-block; align-items: center">
                  <span>用户关注后</span>
                  <a-input-number
                    :min="0"
                    v-model="imgText_hour"
                    style="width: 70px; margin: 0 5px"
                  />
                  <span>小时</span>
                  <a-input-number
                    :min="0"
                    v-model="imgText_minute"
                    style="width: 70px; margin: 0 5px"
                  />
                  <span>分钟</span>
                </div>
              </div>

              <div class="form-cell-box">
                <div class="class-title">开启状态</div>
                <a-switch
                  size="small"
                  :checked="imgText_switch"
                  @change="switchImgText($event)"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
    <SelectUsers
      :visible="r_visible"
      @cancelClick="selectCancel"
      :showList="r_list"
      :id="r_id"
    />
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import SelectUsers from "./components/selectUsers.vue";
import moment from "moment";
import "moment/locale/zh-cn";
import {
  materialList,
  materialChannelSelect,
  materialDel,
  materialCopy,
  gzhGroupGet,
  materialSyncWx,
} from "@/request/api";
export default {
  name: "materialList_",
  components: {
    SelectUsers,
  },
  data() {
    return {
      type_map: {
        1: `H5`,
        2: `H5+小程序`,
        3: `小程序`,
        0: `未知`,
      },
      locale,
      moment,

      bookList: [],
      showBookList: [], // 用于显示
      search_button_loading: false,

      r_page: 1, // 页数
      r_limit: 8, // 每页多少条
      table_total: 0, // 总数

      itemData: [],

      r_name: null,
      r_channel_id: null, // 渠道/书城

      selectData: {}, // 下拉

      left_book_height: 300, // 左边书城列表的高度

      // 同步到微信弹窗
      wx_visible: false,
      wx_confirmLoading: false,

      gzhData: [], // 公众号分组的数据
      s_channel_name: "", // 同步的当前书城
      //   s_id: "", // 同步到微信用的id
      title_channel_name: "", // 选中的渠道/书城名字
      s_add_control: 1, // 是否新建任务，2是，1否
      s_id: null, // 列表ID，用于群发消息
      s_send_type: 1, // 发送类型：1=全部，2=按标签id
      s_send_time_type: 2, // 发送时间类型，1=立即发送，2=定时发送
      s_tag_id: undefined, // send_type=2 必传标签id
      s_send_time: undefined, // send_time_type=2必传时间
      sendTagData: [], // 标签
      aaaaa: true,
      ccccc: false,

      imgText_hour: 0, // 小时
      imgText_minute: 0, // 分钟
      imgText_switch: false, // 开启状态
      imgTxt_checked: false, // 同时设置智能图文
      r_open_send_imgtxt: 1, // 是否同时创建智能图文，2=是，1=否
      r_visible: false,
      r_list: [],
      r_id: [], // 模板id
    };
  },
  mounted() {
    let that = this;

    that.left_book_height =
      document.body.clientHeight - 65 - 20 - 36 - 20 - 24 - 10 - 12;

    materialChannelSelect({
      support_create_message: 1, // 是否支持新建本地图文模板0=否，1=是。
    }).then((res) => {
      that.selectData = res.data.data;
      let c_data = res.data.data.channel;
      const users = res.data.data.user;
      let list = [];
      for (const key in users) {
        if (users[key]) {
          let item = {
            lable: users[key],
            value: key,
            checked: false,
          };
          list.push(item);
        }
      }

      let show_data = [
        {
          key: undefined,
          label: "全部渠道",
          status: true,
        },
      ];
      for (let key in c_data) {
        let ooo = {
          key,
          label: c_data[key],
          status: false,
        };
        show_data.push(ooo);
      }
      // show_data[0].status = true
      that.r_list = list;
      that.bookList = show_data;
      that.showBookList = show_data;
    });

    // 修改母页面的tab高亮状态
    setTimeout(() => {
      that.$bus.$emit("tabPath", that.$route.fullPath);
    }, 300);

    that.searchButton();
  },
  watch: {
    title_channel_name() {
      this.r_id = [];
    },
  },
  methods: {
    //
    checkChange(item, event) {
      if (event.target.checked) {
        this.r_id.push(item.id);
      } else {
        this.r_id = this.r_id.filter((itemy) => itemy != item.id);
      }
    },
    multShareClick() {
      if (this.r_id.length === 0) {
        this.$message.warning(`未选择模板`);
        return;
      }
      this.r_visible = true;
    },
    // 取消
    selectCancel() {
      this.r_id = [];
      this.r_visible = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;
      let r_data = {
        page: that.r_page, // 页数
        limit: that.r_limit, // 每页多少条
        name: that.r_name,
        channel_id: that.r_channel_id, // 书城列表id
      };
      materialList(r_data).then((res) => {
        setTimeout((res) => {
          that.search_button_loading = false;
        }, 300);
        that.table_total = res.data.data.total || 0;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          if (type == "button") {
            that.r_page = 1;
          }
          that.itemData = res.data.data.data;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    goAdd() {
      // this.$router.push({ path:'/materialAdd'})
      if (this.r_channel_id) {
        const { href } = this.$router.resolve({
          path: "/materialAdd",
          query: { chal_id: this.r_channel_id },
        });
        window.open(href, "_blank");
      } else {
        const { href } = this.$router.resolve("/materialAdd");
        window.open(href, "_blank");
      }
    },
    // 切换书城列表
    changeBook(e, index) {
      this.bookList.forEach((res) => {
        res.status = false;
      });
      this.bookList[index].status = true;
      this.r_channel_id = e.key;
      this.title_channel_name = e.label;
      this.searchButton();
    },
    paginationChange(e) {
      this.r_page = e;
      this.searchButton();
    },
    changeSizeLimit(current, pageSize) {
      this.r_limit = pageSize;
      this.searchButton("button");
    },
    // 操作按钮
    handleButton(e, item) {
      let that = this;
      if (e == 1) {
        // 编辑
        const { href } = this.$router.resolve({
          path: "/materialAdd",
          query: { edit_id: item.id },
        });
        window.open(href, "_blank");
      } else if (e == 2) {
        // 复制
        this.$confirm({
          title: "确定要复制吗?",
          content: `名称：${item.name}`,
          onOk() {
            materialCopy({
              id: item.id,
            }).then((res) => {
              if (res.data.code == 0) {
                that.$message.success("复制成功");
                that.searchButton();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          },
          onCancel() {},
        });
      } else if (e == 3) {
        // 删除
        this.$confirm({
          title: "确定要删除吗?",
          content: `名称：${item.name}`,
          okText: "删除",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            materialDel({
              id: item.id,
            }).then((res) => {
              if (res.data.code == 0) {
                that.$message.success("删除成功");
                that.searchButton();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          },
          onCancel() {},
        });
      } else if (e == 4) {
        // 同步到微信
        this.s_channel_name = item.channel_name;
        this.s_id = item.id;
        this.search_button_loading = true;
        gzhGroupGet({
          channel_id: item.channel_id,
        }).then((res) => {
          this.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.list;
            let arr = [];
            for (let key in data) {
              let obj = {
                label: key,
                checked_all: false,
                indeterminate_all: false,
              };
              data[key].forEach((res) => {
                res.checked_z = false;
              });
              obj.value = data[key];
              arr.push(obj);
            }
            that.gzhData = arr;

            that.wx_visible = true;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        });
      } else if (e == 5) {
        // 分享
        that.r_visible = true;
        that.r_id = [item.id];
      }
    },

    // 同步到微信弹窗按钮
    wxHandleOk() {
      let that = this;
      let i_data = []; // 把选中的公众号id放入里面
      that.gzhData.forEach((res) => {
        res.value.forEach((res_z) => {
          if (res_z.checked_z) {
            i_data.push(res_z.id);
          }
        });
      });
      if (i_data.length == 0) {
        that.$message.warning("请选择公众号");
        return;
      }

      let r_data = {
        id: that.s_id,
        gzh_ids: i_data,
        open_send_task: that.s_add_control, // 是否同时开启定时任务，2=是，1=否
      };
      if (that.s_add_control == 2) {
        // 表示要新建定时任务
        let s_type = that.s_send_type;
        if (that.aaaaa) {
          // 如果这里勾选了，等于是固定传-- 按标签选择-星标组
          s_type = 2;
        }
        r_data.send_type = s_type; // 发送类型：1=全部，2=按标签id
        r_data.send_time_type = that.s_send_time_type; // 发送时间类型，1=立即发送，2=定时发送
        if (that.s_send_time_type == 2) {
          // 定时发送才需要传时间
          r_data.send_time = that.s_send_time; // send_time_type= 2必传时间
        }
      }

      // 同时设置智能图文
      if (that.imgTxt_checked) {
        r_data.open_send_imgtxt = that.r_open_send_imgtxt;
        r_data.imgtxt_status = that.imgText_switch ? 1 : 0; // 状态是否开启0=关闭，1=开启
        r_data.imgtxt_delay_time = that.imgText_hour * 60 + that.imgText_minute;
      }
      if (r_data.imgtxt_delay_time < 5) {
        that.$message.warning("推送时间--用户关注后时间最少5分钟");
        return;
      }

      that.wx_confirmLoading = true;
      materialSyncWx(r_data).then((res) => {
        that.wx_confirmLoading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.wxHandleCancel();

          that.$confirm({
            title: res.data.msg || "同步操作成功",
            icon: "exclamation-circle",
            class: "jlzh", //类名
            okText: "查看同步进度",
            cancelText: "取消",
            content: (h) => <div>点击按钮前往-同步微信操作记录</div>,
            onOk() {
              // that.$router.push({path: '/taskSync'});
              const { href } = that.$router.resolve("/syncWxRecord");
              window.open(href, "_blank");
            },
            onCancel() {},
          });
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            //
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    wxHandleCancel() {
      this.wx_visible = false;
    },

    // 全选/取消全选
    onCheckAllChange(e, item, index) {
      let that = this;
      if (that.gzhData[index].checked_all) {
        that.gzhData[index].value.forEach((res) => {
          res.checked_z = false;
        });
        that.gzhData[index].checked_all = false;
      } else {
        that.gzhData[index].value.forEach((res) => {
          res.checked_z = true;
        });
        that.gzhData[index].checked_all = true;
      }
    },
    // 单选
    onCheckChange(e, index, index_z) {
      let that = this;
      that.gzhData[index].value[index_z].checked_z =
        !that.gzhData[index].value[index_z].checked_z;

      let ttt = true; // 用于判断是否全选
      that.gzhData[index].value.forEach((res) => {
        if (!res.checked_z) {
          ttt = false;
        }
      });
      if (ttt) {
        that.gzhData[index].checked_all = true; // 全选
      } else {
        that.gzhData[index].checked_all = false; // 取消全选
      }
    },

    // 页面跳转
    jumpPage(e) {
      if (e == 1) {
        // 公众号分组管理
        this.$router.push({ path: "/gzhGroups", query: {} });
      } else if (e == 2) {
        // 同步微信操作记录
        const { href } = this.$router.resolve("/syncWxRecord");
        window.open(href, "_blank");
      }
    },

    // 搜索书城渠道
    onSearchChal(e) {
      let that = this;
      if (e) {
        let arr = [];
        that.bookList.forEach((res) => {
          if (res.label.indexOf(e) > -1) {
            arr.push(res);
          }
        });
        that.showBookList = arr;
      } else {
        that.showBookList = that.bookList;
      }
    },

    // 是否开启定时任务
    radioHandleA(e) {
      this.s_add_control = e.target.value;
    },
    // 切换群发类型
    messTypeA(e) {
      this.s_send_time_type = e.target.value;
    },
    // 切换人群
    messTypeB(e) {
      this.s_send_type = e.target.value;
    },
    // 发送时间
    onSendChange(date, dateString) {
      this.s_send_time = dateString;
    },
    disabledDate(current) {
      // 今天之前的日期不可选，不包括今天。也就是今天也可以选，今天以及今天以后的日期都可以选
      return current && current < moment().subtract(1, "days");
    },
    handleChangeH(e) {
      this.s_tag_id = e;
    },
    // 是否勾选通过标签星标组
    onTagChange(e) {
      this.aaaaa = e.target.checked;
    },
    onAddChange(e) {
      this.ccccc = e.target.checked;
      if (this.ccccc) {
        this.s_add_control = 2;
      } else {
        this.s_add_control = 1;
      }
    },
    onAddChangeC(e) {
      this.imgTxt_checked = e.target.checked;
      if (e.target.checked) {
        // 是否同时创建智能图文，2=是，1=否
        this.r_open_send_imgtxt = 2;
      } else {
        this.r_open_send_imgtxt = 1;
      }
    },

    // 开启状态
    switchImgText(e) {
      this.imgText_switch = e;
    },
  },
};
</script>

<style scoped>
.left-label {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  margin-bottom: 3px;
}
.left-label:hover {
  /* color: #1890ff;
	background-color: aliceblue; */
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}
.select_menu {
  /* background-color: aliceblue; */
  color: #1890ff;
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}

.item-box {
  width: 300px;
  padding: 25px;
  /* border: 1px solid #ccc; */
  display: inline-block;
  margin: 0 0 30px 30px;
  border-radius: 2px;
  vertical-align: top;
  background: #fff;
  /* box-shadow: 0 0 5px 3px #eee; */
  /* background-color: #F6f7f8; */
  background-color: #fafafa;
}
.item-box-title {
  font-size: 14px;
  /* font-weight: 600; */
  margin-bottom: 18px;
}
.item-top-img {
  width: 100%;
  height: 150px;
}
.item-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
}
.item-cell-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0;
}
.item-cell-img {
  width: 50px;
  height: 50px;
}
.item-button-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
}

.handle-button {
  /* display: inline-block;
	vertical-align: middle;
	text-align: center; */

  padding: 2px 9px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 13px;
  /* color: #40a9ff;
	border: 1px solid #40a9ff; */
  cursor: pointer;
  color: #1890ff;
  border: 1px solid #1890ff;
}
.handle-button:hover {
  background-color: #1890ff;
  color: #fff;
}

/* 设置左侧列滚动条开始 */
/* 滚动条整体 */
.left-menu-box::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  /* height:30px; */
  width: 7px;
  /* 默认：滚动条透明底色 */
  background-color: transparent;
}
/* 滚动条滑块 */
.left-menu-box::-webkit-scrollbar-thumb {
  /* 圆角 */
  border-radius: 10px;
  /* 滑块自身颜色 透明 */
  background-color: transparent;
}
/* 当鼠标hover时 */
.big-menu-box:hover .left-menu-box::-webkit-scrollbar {
  /* 底色 */
  /* background-color:#f3f3f3 !important; */
}
.big-menu-box:hover .left-menu-box::-webkit-scrollbar-thumb {
  /* 滑块颜色 */
  background-color: #999 !important;
}
.left-menu-box::-webkit-scrollbar {
  /* display:none; */
  background-color: transparent;
}
/* 设置左侧列滚动条结束 */
</style>
